import {TmcService} from "./service/TmcService";

import Dialog from "./dialog";

const ModuleName = "tfApp.tmc";

export default angular.module(ModuleName, [Dialog(ModuleName)])
                      .service(TmcService.id, TmcService)
                      .name;
